var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEritrea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2608 18.2607C18.2608 18.2607 5.86951 34.1449 5.85779 34.142C9.47701 37.7613 14.4771 39.9999 20 39.9999C31.0456 39.9999 40 31.0455 40 19.9999L18.2608 18.2607Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2608 19.9999C18.2608 19.9999 5.86951 5.85502 5.85779 5.85783C9.47701 2.23853 14.4771 -6.10352e-05 20 -6.10352e-05C31.0456 -6.10352e-05 40 8.95431 40 19.9999H18.2608Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85785 5.85779C-1.95262 13.6683 -1.95262 26.3316 5.85785 34.1422C5.8573 34.1454 40 20 40 20L5.85785 5.85779Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4349 11.7391C6.59902 11.7391 3.47839 14.8598 3.47839 18.6956V21.3043C3.47839 25.1402 6.5991 28.2608 10.4349 28.2608C14.2707 28.2608 17.3914 25.1401 17.3914 21.3043V18.6956C17.3914 14.8598 14.2707 11.7391 10.4349 11.7391ZM14.7827 21.3044C14.7827 23.2475 13.5013 24.8966 11.7392 25.452V22.6087L13.5848 20.7631L11.7402 18.9185L11.7392 18.262V17.3914H9.13058V20L7.28621 21.8443L9.13058 23.6886V25.4521C7.36847 24.8967 6.08707 23.2476 6.08707 21.3044V18.6958C6.08707 16.2984 8.03753 14.348 10.4349 14.348C12.8322 14.348 14.7827 16.2984 14.7827 18.6958V21.3044Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEritrea);
export default __webpack_public_path__ + "static/media/eritrea.3ac6ca1985caf89553fa045322da1602.svg";
export { ForwardRef as ReactComponent };